// methods and logic for results-list.vue
// include this to in a new component to customize the results-list template for child apps

import { ref, defineProps, getCurrentInstance } from 'vue';

export function useResults() {

    const internalInstance = getCurrentInstance();
    const global = internalInstance.appContext.config.globalProperties;

    const hoverSrc = ref("")
    const expanded = ref(false)
    const metadata = ref({})

    function expand(r){
        const facetableFields = global.$searchFields.facetFields.map((fa) => fa.field);
        for (let field in r._source) {
          const $f = r._source[field];
          if (global.$searchFields.sourceFields[field]) {
            metadata.value[field] = {
              label: global.$searchFields.sourceFields[field],
              value: $f,
              isFacet: (facetableFields.indexOf(field) > -1) ? true : false
            };
          }
        }
        expanded.value = true;
      }

    function filterTerm(field, term){
        global.$eventBus.emit('toggle-filter', { field: field, term: term })
    }
    
    function makeArray(value){
    if(value && Array.isArray(value)){
            return value;
        } else {
            return Array(value);
        }
    }

    function dateFormat(value){
        const date = new Date(value);
        return date.getFullYear();
    }
    
    return {
        hoverSrc,
        expanded,
        metadata,
        expand,
        filterTerm,
        makeArray,
        dateFormat
    }

}


/// See ../components/_result-list.vue for example usage.